import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const AddLinkIcon = (t0)=>{
    const $ = c(8);
    const { width, height, color } = t0;
    let t1;
    let t2;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("path", {
            fill: color,
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 10H12.1247C12.6218 10 13.0247 10.4029 13.0247 10.9C13.0247 11.397 12.6218 11.8 12.1247 11.8H4C3.27023 11.8 2.83116 11.8014 2.50458 11.8281C2.2833 11.8462 2.19842 11.871 2.17932 11.8778C2.04989 11.9445 1.94448 12.0499 1.87778 12.1793C1.871 12.1984 1.84616 12.2833 1.82808 12.5046C1.8014 12.8311 1.8 13.2702 1.8 14C1.8 14.7297 1.8014 15.1688 1.82808 15.4954C1.84616 15.7167 1.871 15.8015 1.87778 15.8206C1.94448 15.9501 2.04989 16.0555 2.17932 16.1222C2.19843 16.129 2.2833 16.1538 2.50458 16.1719C2.83116 16.1986 3.27023 16.2 4 16.2L9.09329 16.2L9.10283 16.2C9.59989 16.2 10.0028 16.6029 10.0028 17.1C10.0028 17.597 9.59989 18 9.10283 18L4 18C2.59987 18 1.8998 17.9999 1.36502 17.7275C0.894619 17.4878 0.512167 17.1053 0.272484 16.6349C0 16.1002 0 15.4001 0 14C0 12.5999 0 11.8998 0.272484 11.365C0.512167 10.8946 0.894619 10.5122 1.36502 10.2725C1.8998 10 2.59987 10 4 10ZM14.6 12.9C14.6 12.4029 15.0029 12 15.5 12C15.997 12 16.4 12.4029 16.4 12.9V14.6001H18.1C18.5971 14.6001 19 15.003 19 15.5001C19 15.9972 18.5971 16.4001 18.1 16.4001H16.4V18.1C16.4 18.5971 15.997 19 15.5 19C15.0029 19 14.6 18.5971 14.6 18.1V16.4001H12.9C12.4029 16.4001 12 15.9972 12 15.5001C12 15.003 12.4029 14.6001 12.9 14.6001H14.6V12.9Z"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            fill: color,
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 4C0 2.59987 0 1.8998 0.272484 1.36502C0.512167 0.894619 0.894619 0.512167 1.36502 0.272484C1.8998 0 2.59987 0 4 0H14C15.4001 0 16.1002 0 16.635 0.272484C17.1054 0.512167 17.4878 0.894619 17.7275 1.36502C18 1.8998 18 2.59987 18 4C18 5.40013 18 6.1002 17.7275 6.63498C17.4878 7.10538 17.1054 7.48783 16.635 7.72752C16.1002 8 15.4001 8 14 8H4C2.59987 8 1.8998 8 1.36502 7.72752C0.894619 7.48783 0.512167 7.10538 0.272484 6.63498C0 6.1002 0 5.40013 0 4ZM4 1.8H14C14.7298 1.8 15.1688 1.8014 15.4954 1.82808C15.7167 1.84616 15.8016 1.871 15.8207 1.87778C15.9501 1.94448 16.0555 2.04989 16.1222 2.17932C16.129 2.19843 16.1538 2.28331 16.1719 2.50458C16.1986 2.83116 16.2 3.27023 16.2 4C16.2 4.72977 16.1986 5.16884 16.1719 5.49542C16.1538 5.71668 16.129 5.80156 16.1222 5.82068C16.0555 5.95011 15.9501 6.05552 15.8207 6.12222C15.8016 6.129 15.7167 6.15384 15.4954 6.17192C15.1688 6.1986 14.7298 6.2 14 6.2H4C3.27023 6.2 2.83116 6.1986 2.50458 6.17192C2.2833 6.15384 2.19843 6.129 2.17932 6.12222C2.04989 6.05552 1.94448 5.95011 1.87778 5.82068C1.871 5.80158 1.84616 5.7167 1.82808 5.49542C1.8014 5.16884 1.8 4.72977 1.8 4C1.8 3.27023 1.8014 2.83116 1.82808 2.50458C1.84616 2.2833 1.871 2.19842 1.87778 2.17932C1.94448 2.04989 2.04989 1.94448 2.17932 1.87778C2.19842 1.871 2.2833 1.84616 2.50458 1.82808C2.83116 1.8014 3.27023 1.8 4 1.8ZM16.1208 5.82399L16.1205 5.82509C16.1205 5.82509 16.1212 5.82343 16.1222 5.82068L16.1208 5.82399Z"
        });
        $[0] = color;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    let t3;
    if ($[3] !== height || $[4] !== t1 || $[5] !== t2 || $[6] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            viewBox: "0 0 20 20",
            width: width,
            height: height,
            children: [
                t1,
                t2
            ]
        });
        $[3] = height;
        $[4] = t1;
        $[5] = t2;
        $[6] = width;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
export { AddLinkIcon };
